import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../../components/sections/Hero';
import WhoWeAre from '../../components/sections/WhoWeAre';
import Team from '../../components/sections/Team';
import Products from '../../components/sections/Products';
import Solutions from '../../components/sections/Solutions';
import Testimonials from '../../components/sections/Testimonials';
import GetInTouch from '../../components/sections/GetInTouch';
import styles from './HomePage.module.css';
import { setupScrollAnimations } from '../../utils/animations';

// Matches the fixed header, same clearance the navbar uses when it
// jumps to a section.
const HEADER_OFFSET = 134;

// The hero scrolls these in order, so the first one is what visitors land on.
const dashboards = [
  {
    label: 'Academics',
    src: '/dashboards/dash-academics.jpg',
    alt: 'Academics dashboard showing average score by subject across two terms, a heat map of subject against assessment type, the mix of assessments, and how students are spread across score bands'
  },
  {
    label: 'Admissions',
    src: '/dashboards/dash-admissions.jpg',
    alt: 'Admissions dashboard showing enquiries by month, enquiry sources, how far enquiries get, and a heat map of source against stage'
  },
  {
    label: 'Receivables',
    src: '/dashboards/dash-receivables.jpg',
    alt: 'Receivables dashboard showing amounts billed against outstanding by fee type, the billing schedule across the year, and where the outstanding money sits'
  },
  {
    label: 'Payments',
    src: '/dashboards/dash-payments.jpg',
    alt: 'Payments dashboard showing collections by month, a donut of payment methods by value, and transaction counts by method'
  }
];

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    const observer = setupScrollAnimations();
    return () => observer.disconnect();
  }, []);

  // Arriving from another page with a section to reach
  useEffect(() => {
    const target = location.state && location.state.scrollTo;
    if (!target) return;
    const timer = setTimeout(() => {
      const element = document.getElementById(target);
      if (!element) return;
      const top = element.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
      window.scrollTo({ top, behavior: 'smooth' });
    }, 120);
    return () => clearTimeout(timer);
  }, [location.state]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (!element) return;
    const scrollPosition =
      element.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
  };
  

  return (
    <div id="home" className={styles.homePage}>
      <Hero
        title="Transform Your Business with Data-Driven Insights"
        description="Unlock the power of analytics to drive growth, optimize operations, and make smarter decisions with Analytica X"
        ctaText="Discover Our Story"
        onCtaClick={() => scrollToSection('who-we-are')}
        media={dashboards}
      />
      
      <WhoWeAre />
      <Team />
      <Products />
      <Solutions />
      <Testimonials />
      <GetInTouch />
    </div>
  );
};

export default HomePage;
